export default __webpack_public_path__ + "static/share-image-6be37e638e20754ca068f8172c6af1f8.png";